import { z } from 'zod'

export const ZRequestContract = z.object({
  rid: z.number(),
  startDate: z.string(),
  endDate: z.string(),
  isExtend: z.boolean().optional(),
  initialContractId: z.number().optional(),
  toHost: z.string().optional(),
})

export type TRequestContract = z.infer<typeof ZRequestContract>

export const ZRequestContractEvent = z.object({
  eventName: z.string(),
  action: z.string(),
  label: z.string(),
  value: z.number(),
  transactionId: z.string(),
  productId: z.number(),
  totalQuantity: z.number(),
  quantity: z.number(),
  price: z.number(),
  period: z.number(),
})

export const RequestContractResponse = z.object({
  finalPayFee: z.number(),
  contractId: z.number(),
  airbridgeEvent: ZRequestContractEvent,
})

export type TRequestContractResponse = z.infer<typeof RequestContractResponse>
export type TRequestContractEvent = z.infer<typeof ZRequestContractEvent>
